import React, { useState, useEffect } from 'react';
import { Table, Input, Button, Card, message, Spin } from 'antd';
import { API_URL, axiosInstance } from '../config';

const { Search } = Input;

const Stock = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [apiSettings, setApiSettings] = useState(null);

    const fetchApiSettings = async () => {
        try {
            const response = await axiosInstance.get('/v1/Settings/getOzoneApi');
            setApiSettings(response.data);
        } catch (error) {
            if (error.response?.status === 404) {
                message.warning('Настройки API Ozon не найдены. Пожалуйста, настройте API в профиле.');
            } else {
                message.error('Ошибка при получении настроек API Ozon');
            }
            console.error('Error fetching API settings:', error);
        }
    };

    const fetchStocks = async () => {
        if (!apiSettings) {
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const headers = token ? { Authorization: `Bearer ${token}` } : {};

            const response = await axiosInstance.get('/v1/Stocks/items', {
                params: {
                    search: searchText
                },
                headers
            });
            
            if (response.data) {
                setData(response.data);
            }
        } catch (error) {
            message.error('Ошибка при загрузке остатков');
            console.error('Error fetching stocks:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchApiSettings();
    }, []);

    useEffect(() => {
        if (apiSettings) {
            fetchStocks();
        }
    }, [apiSettings, searchText]);

    const columns = [
        {
            title: 'Наименование',
            dataIndex: 'name',
            key: 'name',
            width: '40%',
        },
        {
            title: 'Артикул',
            dataIndex: 'article',
            key: 'article',
            width: '20%',
        },
        {
            title: 'Количество',
            dataIndex: 'quantity',
            key: 'quantity',
            width: '20%',
        },
        {
            title: 'Цена',
            dataIndex: 'price',
            key: 'price',
            width: '20%',
            render: (price) => `${price} ₽`,
        },
    ];

    const handleSearch = (value) => {
        setSearchText(value);
    };

    if (!apiSettings) {
        return (
            <div className="container mx-auto p-4">
                <Card>
                    <div className="text-center py-8">
                        <h2 className="text-xl font-semibold mb-4">Настройки API Ozon не найдены</h2>
                        <p className="text-gray-600 mb-4">
                            Для работы с остатками необходимо настроить API Ozon в вашем профиле.
                        </p>
                        <Button type="primary" onClick={() => window.location.href = '/profile'}>
                            Перейти к настройкам
                        </Button>
                    </div>
                </Card>
            </div>
        );
    }

    return (
        <div className="container mx-auto p-4">
            <Card>
                <div className="mb-4">
                    <h1 className="text-2xl font-bold mb-4">Остатки</h1>
                    <Search
                        placeholder="Поиск по наименованию..."
                        allowClear
                        enterButton="Поиск"
                        size="large"
                        onSearch={handleSearch}
                    />
                </div>
                
                <Table
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    rowKey="article"
                    pagination={{
                        pageSize: 50,
                        showSizeChanger: true,
                        showTotal: (total) => `Всего ${total} записей`,
                    }}
                    scroll={{ x: true }}
                />
            </Card>
        </div>
    );
};

export default Stock; 